var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackup = function SvgBackup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78019 11.5449C3.50324 11.3841 1 10.5107 1 9.45714V13.6857C1 14.8535 4.07562 15.8 7.87143 15.8C11.6672 15.8 14.7429 14.8535 14.7429 13.6857V9.45714C14.7429 10.5435 12.0811 11.4384 8.65399 11.5579L6.36181 14.7848L6.78019 11.5449ZM6.91592 10.4938C3.57261 10.3508 1 9.46787 1 8.39981V4.17124C1 5.17734 3.28281 6.01916 6.34225 6.23301L4.12913 9.34866H7.0638L6.91592 10.4938ZM9.43441 10.4592C12.4768 10.2415 14.7429 9.4022 14.7429 8.39981V4.17124C14.7429 5.24327 12.1511 6.12877 8.78961 6.26682L8.63673 7.45069H11.5714L9.43441 10.4592ZM8.92688 5.2038C12.2214 5.0476 14.7429 4.17167 14.7429 3.11429C14.7429 1.94647 11.6672 1 7.87143 1C4.07562 1 1 1.94647 1 3.11429C1 4.19826 3.64987 5.09153 7.06593 5.21421L9.33873 2.01453L8.92688 5.2038Z",
    fill: "#031FEF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backup.3100b68e.svg";
export { ForwardRef as ReactComponent };